import { render, staticRenderFns } from "./CardMeal.vue?vue&type=template&id=518cd9b6"
import script from "./CardMeal.vue?vue&type=script&lang=js"
export * from "./CardMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports